<template>
  <div class="wrapper harit-page d-flex flex-column min-vh-100">
    <AppHeader />
    <div class="body flex-grow-1">
      <CContainer fluid class="harit-shell">
        <!-- Pages rebuilt to the Harit design render their own title and
             breadcrumb (see .harit-page-head). The legacy CoreUI pages still
             rely on this shared one, so it stays for them. -->
        <AppBreadcrumb v-if="!$route.meta.customHead" />
        <router-view />
      </CContainer>
    </div>
    <AppFooter />
  </div>
  <AppAside />
</template>

<script>
import { CContainer } from '@coreui/vue-pro'
import AppAside from '@/components/AppAside.vue'
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppAside,
    AppBreadcrumb,
    AppFooter,
    AppHeader,
    CContainer,
  },
}
</script>

<style lang="scss">
.harit-shell {
  padding: 2rem 2.25rem 2.5rem;
  max-width: 1680px;

  @media (max-width: 768px) {
    padding: 1.25rem 1rem 2rem;
  }
}
</style>
